// Shared header behavior (present on every page): the mobile nav toggle
// and the "Products" dropdown submenu.

// Mobile navigation toggle
(function hamburgerMenu() {
  const toggle = document.querySelector(".navbar__toggle");
  const menu = document.querySelector(".navbar .navbar__menu");

  if (toggle && menu) {
    toggle.addEventListener("click", (e) => {
      e.stopPropagation();
      if (menu.style.maxHeight) {
        menu.style.maxHeight = null;
        toggle.setAttribute("aria-expanded", "false");
      } else {
        menu.style.maxHeight = menu.scrollHeight + "px";
        toggle.setAttribute("aria-expanded", "true");
      }

      document.body.addEventListener("click", () => {
        if (menu.style.maxHeight) {
          menu.style.maxHeight = null;
        }
        toggle.removeAttribute("aria-expanded");
      });
    });
    document.addEventListener("click", () => {
      menu.style.maxHeight = null;
      toggle.setAttribute("aria-expanded", "false");
    });

    menu.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  }
})();

// Dropdown submenu
(function subMenu() {
  const liLinks = document.querySelectorAll(".navbar__links li");
  const menu = document.querySelector(".navbar .navbar__menu");

  liLinks.forEach((li) => {
    const submenu = li.querySelector(".sub-menu");

    if (!submenu) return;

    li.addEventListener("click", (e) => {
      e.stopPropagation();

      if (li.classList.contains("active")) {
        liLinks.forEach((li) => li.classList.remove("active"));
      } else {
        li.classList.add("active");
      }
      if (submenu.style.maxHeight) {
        submenu.style.maxHeight = null;
        const menuHeight = menu.scrollHeight - submenu.scrollHeight;
        menu.style.maxHeight = menuHeight + "px";
      } else {
        submenu.style.maxHeight = submenu.scrollHeight + "px";
        const menuHeight = menu.scrollHeight + submenu.scrollHeight;
        menu.style.maxHeight = menuHeight + "px";
      }
    });

    document.body.addEventListener("click", () => {
      liLinks.forEach((li) => {
        li.classList.remove("active");

        const submenu = li.querySelector(".sub-menu");
        if (submenu) {
          submenu.style.maxHeight = null;
        }
      });
    });
  });
})();
